import { createFileRoute } from "@tanstack/react-router";

import { PipelineTestbenchShell } from "@/components/pipeline-testbench/pipeline-testbench-shell";
import { PageHeader, type PageHelp } from "@/components/shared/page-help";

export const Route = createFileRoute("/pipeline-testbench")({
	component: PipelineTestbenchPage,
});

function PipelineTestbenchPage() {
	return (
		<div className="mx-auto flex max-w-7xl flex-col gap-5">
			<PageHeader
				moduleId="P2"
				title="链路测试台"
				description="把一句客户问题拆成可验证的处理链路，逐步看清数据模式、意图、方案、工具、知识、回复和审计结果。"
				help={pipelineHelp}
			/>
			<PipelineTestbenchShell />
		</div>
	);
}

const pipelineHelp: PageHelp = {
	title: "链路测试台说明",
	description: "这里用于把黑盒客服回复拆开，帮助产品、运营、QA 和研发按同一条链路验收。",
	sections: [
		{
			title: "先看什么",
			items: [
				"先确认数据模式：Mock、沙盒、真实只读、真实写入的证据效力不同。",
				"再看 15 个链路节点：节点不能因为未配置或受限而被隐藏。",
				"最后看运行结论：最终回复、动作结果、证据引用和审计记录必须能串起来。",
			],
		},
		{
			title: "怎么判断问题在哪",
			items: [
				"意图不对，回到意图分类；方案不对，回到处理方案。",
				"事实缺失，先区分是 Shopify 权限、Qdrant 未配置，还是 mock 数据不足。",
				"最终回复不稳定，回到提示词与话术，并在评测运营把坏样本纳入后续测试集。",
			],
		},
		{
			title: "当前边界",
			items: [
				"Shopify 订单与客户数据仍受 PCD 审批限制，页面会保留受限节点。",
				"知识检索以 runtime_capabilities 为准；空结果先排查 namespace、索引和样本问题。",
				"写操作默认保护性试跑，不能把沙盒通过理解为真实写入已执行。",
			],
		},
		{
			title: "规则在哪里改",
			items: [
				"分类规则回到意图分类，方案映射和预取条件回到处理方案。",
				"工具是否可用回到工具与动作，知识内容回到知识与证据。",
				"最终回复话术回到提示词与话术，质量结果回到质量策略。",
			],
		},
	],
};
